import React, {useEffect, useState} from "react";
import {Modal, notification, Table, Tag} from "antd";
import {ClockCircleOutlined} from "@ant-design/icons";
import Spinner from "../../spinner";
import {billingServices} from "../../../services/billing.services";
import i18n from "../../../i18n";

// Метки типов действий депозита
const ACTION_LABELS = {
    replenishment: 'Пополнение',
    spending: 'Списание',
};

export default function ModalDepositHistory({depositId, isShow, setIsShow}) {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(false);

    // Безопасное извлечение payload из ответа API: { status, data } -> data
    function getPayload(response) {
        if (response && response.data && response.data.data) {
            return response.data.data;
        }
        return [];
    }

    useEffect(() => {
        if (depositId && isShow) {
            setLoading(true);
            billingServices.getDepositHistory(depositId)
                .then((response) => {
                    setHistory(getPayload(response) || []);
                })
                .catch((err) => {
                    const description = typeof err === 'string'
                        ? err
                        : (err && err.message ? err.message : err);
                    notification.error({
                        message: i18n.t('components.notification.titles.subscription'),
                        description: description,
                    });
                })
                .finally(() => setLoading(false));
        }
    }, [depositId, isShow]);

    function formatAmount(value) {
        if (value === null || value === undefined) {
            return '—';
        }
        return Number(value).toLocaleString('ru-RU', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }) + ' ₽';
    }

    function formatActionType(type) {
        const label = ACTION_LABELS[type] ? ACTION_LABELS[type] : type;
        const color = type === 'replenishment' ? 'green' : 'red';
        return <Tag color={color}>{label}</Tag>;
    }

    function formatDocument(record) {
        if (record.invoiceId) {
            // Счёт: номер и дата
            const number = record.invoiceNumber ? '№' + record.invoiceNumber : '';
            const date = record.invoiceDate ? ' от ' + record.invoiceDate : '';
            if (!number && !date) {
                return 'Счёт';
            }
            return 'Счёт ' + number + date;
        }
        if (record.subscriptionId) {
            // Подписка: наименование юр. лица и тариф
            const legalEntity = record.legalEntityName ? record.legalEntityName : '';
            const tariff = record.tariffName ? record.tariffName : '';
            if (legalEntity && tariff) {
                return legalEntity + ' — ' + tariff;
            }
            if (legalEntity) {
                return legalEntity;
            }
            if (tariff) {
                return tariff;
            }
            return 'Подписка №' + record.subscriptionId;
        }
        return '—';
    }

    const columns = [
        {
            title: 'Дата',
            dataIndex: 'createdAt',
            key: 'createdAt',
        },
        {
            title: 'Тип',
            key: 'actionType',
            render: (_, record) => formatActionType(record.actionType),
        },
        {
            title: 'Сумма',
            dataIndex: 'amount',
            key: 'amount',
            render: (value) => formatAmount(value),
        },
        {
            title: 'Документ',
            key: 'document',
            render: (_, record) => formatDocument(record),
        },
        {
            title: 'Пользователь',
            key: 'user',
            render: (_, record) => {
                if (record.userFio) {
                    return record.userFio;
                }
                if (record.userId) {
                    return 'Пользователь №' + record.userId;
                }
                return '—';
            },
        },
    ];

    return (
        <Modal
            title={<span><ClockCircleOutlined/> История депозита</span>}
            cancelText={i18n.t('main.buttons.close')}
            className="modal-window"
            align={null}
            visible={isShow}
            onCancel={() => setIsShow(false)}
            footer={null}
        >
            <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
                <Table
                    columns={columns}
                    dataSource={history}
                    bordered={true}
                    pagination={false}
                    locale={{emptyText: i18n.t('main.empty')}}
                    className="employees-table"
                    rowKey="id"
                />
            </Spinner>
        </Modal>
    );
}
